/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_F_RkidInputs */

const cs_pm_f_rkid = /** @type {(inputs: Pm_F_RkidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RK ID (rkid)`)
};

const en_pm_f_rkid = /** @type {(inputs: Pm_F_RkidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agency ID (rkid)`)
};

/**
* | output |
* | --- |
* | "Agency ID (rkid)" |
*
* @param {Pm_F_RkidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_f_rkid = /** @type {((inputs?: Pm_F_RkidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_F_RkidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_f_rkid(inputs)
	return cs_pm_f_rkid(inputs)
});